import { message } from "antd";
import axios from "axios";
import { apiHeaders } from "../helper/apiHeader";
import {
  allCalId,
  allMPCalId,
  allPECalId,
  allRACalId,
} from "../helper/constant/calibrationSectionId";
import { getStudentData } from "../helper/localStorage";

export const fetchCalibrationApi = (
  sectionId,
  dispatchLaunchTest,
  dispatchHelper
) => {
  const myData = {
    data: {
      player_id: getStudentData().login_id,
      grade_id: getStudentData().grade_id,
      test_id: sectionId,
    },
  };

  dispatchLaunchTest({
    type: "LOADER",
  });

  axios
    .post("/MetaData", myData, apiHeaders("launchcalibration"))
    .then((res) => {
      if (res.data.status === "201") {
        dispatchLaunchTest({ type: "RUNNING_TEST_DATA", payload: res.data });
        dispatchHelper({
          type: "RUNNING_QUES_ID",
          payload:
            sectionId === allMPCalId || // memory processing id
            sectionId === allCalId // ALL CALIBRATION id // "11862"
              ? "23dnb"
              : sectionId === allRACalId // reasoning ability
              ? res.data.non_audio.data[0].que[0].id
              : sectionId === allPECalId // Processing Efficiency
              ? res.data.simple_reaction.data[0].que[0].id
              : res.data.audio.data[0].que[0].id,
        });
      } else {
        message.error(res.data.msg);
        dispatchLaunchTest({
          type: "ERR",
        });
      }
    })
    .catch((err) => {
      message.error("Please wait for sometime or check your internet connection. Try again!");
      dispatchLaunchTest({
        type: "ERR",
      });
    });
};
